import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { KeyboardService } from '../../../keyboard/keyboard.service';

@Component({
  selector: 'form-input-currency',
  styleUrls: ['form-input.component.sass'],
  template: `
    <div class="dynamic-field form-input" [formGroup]="group">
      <mat-form-field appearance="outline">
        <mat-label>{{ config.label }}</mat-label>
        <input
          currencyMask
          class="mat-form-field uppercase"
          matInput
          [attr.placeholder]="config.placeholder"
          [formControlName]="config.name"
        />
      </mat-form-field>
    </div>
  `,
})
export class FormInputCurrencyComponent implements Field {
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;

  constructor(public keyboardService: KeyboardService) {}

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
